import React, { Fragment, useState } from "react";
import { Navbar, Nav, Dropdown } from "react-bootstrap";
import { navigate, useMatch } from "@reach/router";
import SearchArticulo from './search-articulo';
import useLogin from "../providers/use_login";
import background from "../assets/fondo-aer.jpg"

const WikiNavBar = ({ isSticky = true, showSearch = true }) => {
  const { user, logout, isReady } = useLogin();
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const isAzarAlready = useMatch('/articulo/')

  return (
    <Fragment>
      <Navbar
        sticky={isSticky ? "top" : undefined}
        bg="dark"
        variant="dark"
        expand="sm"
        style={{ backgroundImage: `url(${background})`, color: '#aaa', backgroundSize: 'cover' }}
      >
        <Navbar.Brand href="https://aerandir.foroes.org">
          Volver a Aerandir
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link onClick={() => navigate("/")}>Inicio</Nav.Link>
            <Nav.Link
              onClick={() =>
                isAzarAlready ? window.location.reload() : navigate("/articulo/")
              }
            >
              Al Azar
            </Nav.Link>
          </Nav>
          {showSearch && <SearchArticulo />}
          {user ? (
            <Dropdown
              navbar
              show={showUserDropdown}
              alignRight
              onToggle={(newVal) => setShowUserDropdown(newVal)}
            >
              <Dropdown.Toggle
                bsPrefix="searchbar"
                variant="success"
                id="dropdown-search"
                as={"span"}
              >
                <div
                  style={{
                    backgroundColor: "#1b1b1b",
                    color: "#aaa",
                    fontSize: "25px",
                    lineHeight: "50px",
                    textAlign: "center",
                    marginLeft: 10,
                    borderRadius: "50%",
                    height: "50px",
                    width: "50px",
                    cursor: "pointer"
                  }}
                >
                  {user.displayName.substring(0, 1) || "U"}
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => {
                  navigate("/micuenta")
                }}>
                  Mi Cuenta
                </Dropdown.Item>
                {user.role === "admin" && <Dropdown.Item
                  onClick={() => {
                    navigate("/admin");
                  }}
                >
                  Panel de Admin
                </Dropdown.Item>}
                {user.activo && <Dropdown.Item
                  onClick={() => {
                    navigate("/nuevo");
                  }}
                >
                  Proponer Artículo
                </Dropdown.Item>}
                <Dropdown.Item
                  onClick={() => {
                    logout();
                  }}
                >
                  Cerrar Sesión
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          ) : (
              <>
                {isReady && <Nav.Link onClick={() => navigate("/login")}>
                  Iniciar Sesión
            </Nav.Link>}
              </>
            )}
        </Navbar.Collapse>
      </Navbar>
    </Fragment>
  );
};

export default WikiNavBar;
